import { render, staticRenderFns } from "./OverdueNotice.vue?vue&type=template&id=35253df6&scoped=true"
import script from "./OverdueNotice.vue?vue&type=script&lang=js"
export * from "./OverdueNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35253df6",
  null
  
)

export default component.exports